"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.leadSourceIngressResponseSchema = exports.leadSourceIngressPayloadV1Schema = exports.leadSourceConnectionListResponseSchema = exports.leadSourceConnectionSchema = exports.leadSourceConnectionStatusSchema = exports.leadSourceProviderSchema = void 0;
const zod_1 = require("zod");
const job_inbox_1 = require("./job-inbox");
exports.leadSourceProviderSchema = zod_1.z.enum([
    "GOOGLE_BUSINESS_PROFILE",
    "GOOGLE_LOCAL_SERVICES",
    "ANGI",
    "THUMBTACK",
    "ELOCAL",
    "API",
]);
exports.leadSourceConnectionStatusSchema = zod_1.z.enum([
    "NOT_CONNECTED",
    "CONNECTED",
    "DISABLED",
    "NEEDS_ATTENTION",
]);
exports.leadSourceConnectionSchema = zod_1.z.object({
    provider: exports.leadSourceProviderSchema,
    displayName: zod_1.z.string().min(1).max(120),
    status: exports.leadSourceConnectionStatusSchema,
    appId: zod_1.z.string().min(3).max(80).nullable(),
    installationId: zod_1.z.string().uuid().nullable(),
    lastReceivedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    lastErrorAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    lastErrorCode: zod_1.z.string().max(120).nullable(),
});
exports.leadSourceConnectionListResponseSchema = zod_1.z.object({
    connections: zod_1.z.array(exports.leadSourceConnectionSchema),
});
/**
 * Provider adapters normalize native payloads into this versioned envelope
 * before handing them to CrewFSM's public connector ingress.
 */
exports.leadSourceIngressPayloadV1Schema = zod_1.z.object({
    schemaVersion: zod_1.z.literal("1"),
    externalSourceId: zod_1.z.string().trim().min(1).max(255),
    title: zod_1.z.string().trim().min(1).max(160),
    summary: zod_1.z.string().trim().max(2_000).nullable(),
    contact: job_inbox_1.jobInboxContactSchema,
    serviceAddress: job_inbox_1.jobInboxServiceAddressSchema.nullable(),
    attribution: job_inbox_1.jobInboxAttributionSchema.nullable(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).default({}),
    occurredAt: zod_1.z.string().datetime({ offset: true }),
});
exports.leadSourceIngressResponseSchema = zod_1.z.object({
    accepted: zod_1.z.literal(true),
    duplicate: zod_1.z.boolean(),
    itemId: zod_1.z.string().uuid(),
});
//# sourceMappingURL=lead-source-connection.js.map